import { render, staticRenderFns } from "./contact-modal.vue?vue&type=template&id=0df06014&"
import script from "./contact-modal.vue?vue&type=script&lang=js&"
export * from "./contact-modal.vue?vue&type=script&lang=js&"
import style0 from "./contact-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports